import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Footer from "./includes/Footer";
import { Field, reduxForm } from "redux-form";
import { contactToEnterprise, clearContHrMessage } from "../actions";
import $ from "jquery";
import { FormattedMessage } from "react-intl";
import ReCAPTCHA from "react-google-recaptcha";

class ContactToEnterprise extends Component {
  constructor(props) {
    super(props);
    this.state = {
      roles: [],
      language: null,
      testType: null,

      // ✅ captcha state
      recaptchaToken: null,
      recaptchaError: null,
    };

    window.scrollTo(0, 0); // scroll page to top
    this.contactHrForm = this.contactHrForm.bind(this);
    this.onCaptchaChange = this.onCaptchaChange.bind(this);
    this.onCaptchaExpired = this.onCaptchaExpired.bind(this);
  }

  componentDidMount() {
    if (this.props.isSignedIn) {
      let testType = localStorage.getItem("testType");
      this.setState({ testType: testType });

      let language;
      if (this.props.lang === "en") language = "english";
      if (this.props.lang === "fr") language = "french";
    }
  }

  onCaptchaChange(token) {
    this.setState({ recaptchaToken: token, recaptchaError: null });
  }

  onCaptchaExpired() {
    this.setState({
      recaptchaToken: null,
      recaptchaError: "Captcha expired. Please verify again.",
    });
  }

  contactHrForm(values) {
    // ✅ block submit if captcha not verified
    if (!this.state.recaptchaToken) {
      this.setState({ recaptchaError: "Please verify captcha before submit." });
      return;
    }

    values["language"] = this.props.lang;

    // ✅ send captcha token to Laravel
    values["captcha_token"] = this.state.recaptchaToken;

    $("#contactus-loader").show();
    this.refs.sbmt.setAttribute("disabled", "disabled");

    this.props.contactToEnterprise(values, this.refs.sbmt, (response) => {
      if (response === "success") {
        this.props.reset("contactUsValidation");
        $("#contactus-loader").hide();

        // reset captcha token after success
        this.setState({ recaptchaToken: null, recaptchaError: null });

        setTimeout(function () {
          window.location = "/hr";
        }, 10000);
      } else {
        // if failed, re-enable submit
        $("#contactus-loader").hide();
        this.refs.sbmt.removeAttribute("disabled");
      }
    });
  }

  renderInput(field) {
    return (
      <div className="form-group">
        <label>{field.label}</label>
        <input
          type={field.type}
          className="form-control"
          placeholder={field.placeholder}
          autoComplete="off"
          {...field.input}
        />
        {field.meta.touched && field.meta.error && (
          <small className="text-danger">{field.meta.error}</small>
        )}
      </div>
    );
  }

  renderTextarea(field) {
    return (
      <div className="form-group">
        <label>{field.label}</label>
        <textarea
          type={field.type}
          className="form-control md-textarea"
          placeholder={field.placeholder}
          {...field.input}
        ></textarea>
        <p>
          <FormattedMessage
            id="contact.us.textareaexp"
            defaultMessage="* required"
          />
        </p>
        {field.meta.touched && field.meta.error && (
          <small className="text-danger">{field.meta.error}</small>
        )}
      </div>
    );
  }

  errorMessage() {
    if (this.props.contactHrError !== null && this.props.contactHrError !== "") {
      return (
        <div className="col-md-12 alert alert-danger" role="alert">
          {this.props.contactHrError}
        </div>
      );
    }
    if (this.props.contactHrMessage !== null && this.props.contactHrMessage !== "") {
      return (
        <div className="col-md-12 alert alert-success" role="alert">
          {this.props.contactHrMessage}
        </div>
      );
    }
  }

  render() {
    const { testType } = this.state;

    var contact_hr_title = "contact_hr_title_ent";
    var contact_hr_sub_title = "contact_hr_sub_title_ent";

    const firstname = (
      <FormattedMessage
        id="contact.us.name"
        defaultMessage="First name, Name *"
      />
    );
    const emailaddress = (
      <FormattedMessage
        id="contact.us.emailaddress"
        defaultMessage="Email address *"
      />
    );
    const phoneno = (
      <FormattedMessage
        id="contact.us.phoneno"
        defaultMessage="Phone Number *"
      />
    );
    const company = (
      <FormattedMessage
        id="contact.us.company"
        defaultMessage="Name of company *"
      />
    );
    const designation = (
      <FormattedMessage
        id="contact.us.designation"
        defaultMessage="Designation"
      />
    );

    // ✅ Use your site key (env preferred)
    const RECAPTCHA_SITE_KEY_NEW = "6Ldn0VcsAAAAAFg2CyFl6lpg37k6XN64zROfXsgn";
    const RECAPTCHA_SITE_KEY =
      RECAPTCHA_SITE_KEY_NEW || "6Ldn0VcsAAAAAFg2CyFl6lpg37k6XN64zROfXsgn";

    return (
      <React.Fragment>
        <section className="mb-4 pages">
          <div className="container">
            {this.props.contactHrMessage == null ? (
              <div className="row">
                <h2 className="h1-responsive font-weight-bold text-center my-4 w-100">
                  <FormattedMessage
                    id={contact_hr_title}
                    defaultMessage={contact_hr_title}
                  />
                </h2>
                <p className="text-center w-responsive mx-auto mb-5">
                  <FormattedMessage
                    id={contact_hr_sub_title}
                    defaultMessage={contact_hr_sub_title}
                  />
                </p>

                <div className="row w-100">{this.errorMessage()}</div>

                <form
                  id="contact-hr"
                  onSubmit={this.props.handleSubmit((e) => this.contactHrForm(e))}
                  className="row w-100"
                >
                  <div className="col-lg-10 col-md-12 p-0 m-0">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <Field
                            name="name"
                            type="text"
                            label={firstname}
                            placeholder=""
                            className="form-control"
                            component={this.renderInput}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <Field
                            name="email"
                            type="email"
                            label={emailaddress}
                            placeholder=""
                            className="form-control"
                            component={this.renderInput}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <Field
                            name="phone"
                            type="tel"
                            label={phoneno}
                            placeholder="(0)9 83 20 00 15"
                            className="form-control"
                            component={this.renderInput}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <Field
                            name="company"
                            type="text"
                            label={company}
                            className="form-control"
                            placeholder=""
                            component={this.renderInput}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="md-form mb-0">
                          <Field
                            name="designation"
                            type="text"
                            label={designation}
                            className="form-control"
                            placeholder=""
                            component={this.renderTextarea}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 col-md-12 d-flex flex-column p-0 m-0 text-center">
                    <ul className="list-unstyled mb-0">
                      <li>
                        <i className="fa fa-map-marker"></i>
                        <p>4 rue des Fosses Saint-Jacques 75005 PARIS</p>
                      </li>
                      <li>
                        <i className="fa fa-phone"></i>
                        <p>+ 33 (0) 9 83 20 00 15</p>
                      </li>
                      <li>
                        <i className="fa fa-envelope"></i>
                        <p>contact@pilotrhsolutions.com</p>
                      </li>
                    </ul>
                  </div>

                  {/* ✅ CAPTCHA added here (above submit) */}
                  <div className="col-md-12 text-center" style={{ marginTop: 10 }}>
                    <ReCAPTCHA
                      sitekey={RECAPTCHA_SITE_KEY}
                      onChange={this.onCaptchaChange}
                      onExpired={this.onCaptchaExpired}
                    />
                    {this.state.recaptchaError ? (
                      <small className="text-danger d-block mt-2">
                        {this.state.recaptchaError}
                      </small>
                    ) : null}
                  </div>

                  <div className="col-md-12 text-center">
                    <div
                      className="spinner-border text-primary m-auto"
                      role="status"
                      id="contactus-loader"
                    >
                      <span className="sr-only">
                        <FormattedMessage id="loading" defaultMessage="Loading..." />
                      </span>
                    </div>
                  </div>

                  <div className="col-md-12 text-center">
                    <input type="hidden" name="language" value={this.props.lang} />

                    <button
                      type="submit"
                      name="send-query"
                      id="send-query"
                      tabIndex="4"
                      className="btn btn-primary"
                      ref="sbmt"
                      disabled={!this.state.recaptchaToken}
                    >
                      <FormattedMessage id="submit" defaultMessage="SUBMIT" />
                    </button>
                  </div>

                  <div className="status"></div>
                </form>
              </div>
            ) : (
              <div className="row">
                <div className="col-md-12 p-4 m-0 text-center">
                  {this.errorMessage()}
                  <div className="col-sm-12 mx-auto text-center mb-4 pb-45">
                    <Link to="/hr" className="btn btn-warning mt-3 mx-3">
                      <FormattedMessage
                        id="do_another_test"
                        defaultMessage="DO ANOTHER TEST"
                      />
                    </Link>
                    <Link to="/" className="btn btn-primary mt-3 mx-3">
                      <FormattedMessage
                        id="back_to_home"
                        defaultMessage="BACK TO HOME PAGE"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        <Footer />
      </React.Fragment>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Name is required";
  }
  if (!values.email) {
    errors.email = "Email address is required";
  }
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = "Invalid email";
  }
  if (!values.phone) {
    errors.phone = "Phone number is required";
  }
  if (
    values.phone &&
    !/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/i.test(values.phone)
  ) {
    errors.phone = "Invalid phone number";
  }
  if (!values.company) {
    errors.company = "Name of company is required";
  }
  if (!values.designation) {
    errors.designation = "Designation is required";
  }
  return errors;
};

const mapStateToProps = (state) => {
  return {
    isSignedIn: state.auth.isSignedIn,
    contactUsValidation: state.form.contactUsValidation,
    contactHrError: state.auth.contactHrError,
    contactHrMessage: state.auth.contactHrMessage,
    lang: state.locale.lang,
  };
};

ContactToEnterprise = connect(mapStateToProps, {
  contactToEnterprise,
  clearContHrMessage,
})(ContactToEnterprise);

export default reduxForm({
  form: "contactUsValidation",
  enableReinitialize: true,
  validate,
})(ContactToEnterprise);
